/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Box, ContentBlock } from 'sarsaparilla';

export default function WhiteAndGrayBoxes({ children }) {
    let skip = 0;
    return (
        <>
            {React.Children.map(children, (child, index) => {
                if (child) {
                    return (
                        <Box
                            background={
                                (index - skip) % 2 ? 'extra-light-blue' : undefined
                            }
                        >
                            <ContentBlock>{child}</ContentBlock>
                        </Box>
                    );
                }
                skip += 1;
                return null;
            })}
        </>
    );
}

WhiteAndGrayBoxes.propTypes = {
    children: PropTypes.node,
};
